export default function PHP_Concatenate_Strings() {
  return (
    <div>
      <h1>PHP_Concatenate_Strings</h1>
    </div>
  );
}
